import { PicklistProps } from 'react-rainbow-components/components/Picklist';

const isEmptyValue = (value: PicklistProps | string) => value === undefined || value === null || value === '';

const isStateOrAreaCodeValidator = (value: PicklistProps | string) => (isEmptyValue(value) ? ' ' : undefined);

export default isStateOrAreaCodeValidator;
